export default "__VITE_ASSET__CHGGEWpY__"